import React, { useState } from 'react';
import { 
  ArrowLeft
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import { VisualTemplateBuilder } from './VisualTemplateBuilder';
import { VisualTemplateGallery } from './VisualTemplateGallery';
import { PreApprovalTemplate } from '@/types/pre-approval';

interface TemplateBuilderProps {
  onTemplateSelect?: (template: PreApprovalTemplate) => void;
}

// Define TemplateLayout to match what VisualTemplateBuilder expects
interface TemplateLayout {
  id: string;
  name: string;
  pageSize: 'letter' | 'a4';
  orientation: 'portrait' | 'landscape';
  margins: {
    top: number;
    bottom: number;
    left: number;
    right: number;
  };
  elements: Array<{
    id: string;
    type: 'text' | 'image' | 'divider' | 'signature';
    content?: string;
    imageUrl?: string;
    x: number;
    y: number;
    width: number;
    height: number;
    styles: {
      fontSize: number;
      fontFamily: string;
      fontWeight: 'normal' | 'bold';
      fontStyle: 'normal' | 'italic';
      textDecoration: 'none' | 'underline';
      textAlign: 'left' | 'center' | 'right';
      color: string;
      backgroundColor?: string;
      padding: number;
      borderRadius: number;
      border?: string;
      lineHeight?: number;
    };
  }>;
  createdAt: string;
  updatedAt: string;
}

export const TemplateBuilder: React.FC<TemplateBuilderProps> = ({
  onTemplateSelect
}) => {
  const [mode, setMode] = useState<'gallery' | 'editor'>('gallery');
  const [selectedTemplate, setSelectedTemplate] = useState<TemplateLayout | null>(null);

  const handleCreateNew = () => {
    setSelectedTemplate(null);
    setMode('editor');
  };

  const handleSelectTemplate = (template: TemplateLayout) => {
    setSelectedTemplate(template);
    setMode('editor');
  };

  const handleBackToGallery = () => {
    setMode('gallery');
    setSelectedTemplate(null);
  };

  if (mode === 'editor') {
    return (
      <VisualTemplateBuilder
        initialTemplate={selectedTemplate || undefined}
        onTemplateSelect={onTemplateSelect}
        onBackToGallery={handleBackToGallery}
      />
    );
  }

  return (
    <div className="space-y-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-foreground">Pre-Approval Templates</h1>
        <p className="text-muted-foreground">Manage your pre-approval letter templates</p>
      </div>
      {/* Template Gallery */}
      <VisualTemplateGallery
        onCreateNew={handleCreateNew}
        onSelectTemplate={handleSelectTemplate}
      />
    </div>
  );
};